@if(breakpointService.isDesktop()) {
  <app-region-info-page-desktop
    [isFetching]="isFetching"
    [countryResponse]="countryResponse"
    [countryDetails]="countryDetails"
    [regionResponse]="regionResponse"
    [regionDetails]="regionDetails"
    [breadcrumbs]="breadcrumbs"
    [defaultLocationName]="defaultLocationName"
  ></app-region-info-page-desktop>
} @else {
  <app-region-info-page-mobile
    [isFetching]="isFetching"
    [countryResponse]="countryResponse"
    [countryDetails]="countryDetails"
    [regionResponse]="regionResponse"
    [regionDetails]="regionDetails"
    [breadcrumbs]="breadcrumbs"
    [defaultLocationName]="defaultLocationName"
  ></app-region-info-page-mobile>
}
